<template>
    <div>
        <div class="logo">
            <div class="search">
                <div class="fr lang">
                    <div class="colsela">
                        <div class="choose">
                            <select id="Language" v-model="this.idActive" @change="changeProduct($event)">
                                <option ref="name" v-for="i in this.list" :value= i.id >{{i.name}}</option>
                            </select>
                        </div>
                        
                    </div>
                    <!-- <div><svg t="1570847469192" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3415" width=".45rem" height=".45rem"><path d="M777.045333 345.642667 512 611.648 246.976 345.642667c-12.565333-12.629333-32.981333-12.629333-45.546667 0s-12.565333 33.130667 0 45.76L487.616 678.613333c6.698667 6.741333 15.594667 9.6 24.384 9.173333 8.789333 0.448 17.664-2.410667 24.384-9.173333l286.208-287.210667c12.544-12.629333 12.544-33.130667 0-45.76C810.005333 333.013333 789.632 333.013333 777.045333 345.642667z" p-id="3416" fill="#ffffff"></path></svg></div> -->
                </div>
                <div class="inputA fr">
                    <div class="icon-search">
                        <svg t="1570870517269"  @click="search()" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4302" width=".8rem" height=".8rem"><path d="M897.2 882.3l-210-221.1c54.5-57.7 85.6-132.5 87.5-212.4 2.1-86-28.8-167.7-88.1-230.1-59.3-62.5-139.4-98.2-225.3-100.4h-8.5c-82.8 0-161.2 31-221.6 88.1-128.7 122.3-134.6 326.8-12.3 455.5 59.3 62.5 139.4 98.2 225.3 100.4h9.1c76.3 0 148.6-26.8 206.7-75.4l210.1 221.2 27.1-25.8zM453.3 719.5h-8.5c-74.3-2-143.5-32.9-194.9-87.1-106-111.5-101.1-288.7 10.7-395 52-49.3 120.3-76.4 192.2-76.4h8c74.3 2 143.5 32.9 194.9 87.1 51.1 53.9 78.2 124.8 76.4 199.7-1.9 74.5-32.8 143.9-86.9 195.2-52.7 49.3-120.8 76.5-191.9 76.5z" p-id="4303" fill="#bfbfbf"></path></svg>
                    </div>
                    <input type="text" class="inputb" v-model="title" placeholder="请输入内容">
                </div>
                <div class="clear"></div>
            </div>
            <div class="wnav"><Nav></Nav></div>
        </div>
    </div>
</template>
<script>
import { getLanguage } from '@/api/user'
export default {
    data(){
        return{
            input:'',
            list:[],
            idActive:localStorage.getItem("key"),   //获取被选中的value值 默认选中的是1(中文)
            title:'',
        }
    },
    beforeMount () {
        this.getLanguage();
    },
    methods:{
        search(){
            this.$router.push({name:'Search',query:{title:this.title}})
        },
        changeProduct(event){
            this.idActive = event.target.value;
            localStorage.setItem("key",this.idActive);
            this.idActive = localStorage.getItem("key")
            // if (this.idActive == 1) {
            //     this.$router.push({path: '/home/?id=1'})
            // }else if(this.idActive == 2){
            //     this.$router.push({path: '/home/?id=38'})
            // }
            this.$router.push({path: '/home/?id=1'})
            window.location.reload();
            // console.log(this.$route.path)
            // console.log(this.$route)
            // window.location.replace(this.$route.path);
        },
        getLanguage(){
            getLanguage().then(res =>{
                if(localStorage.getItem("key") == null){
                    localStorage.setItem("key",'1')
                    this.idActive = localStorage.getItem("key") 
                }
                if(res.code == "200"){
                    this.list = res.data.list
                }
            })
        },
    }
}
</script>
<style scoped>
.wnav{
    width: 100%;
    height: 1.3rem;
    line-height: 1.3rem;
    position: absolute;
    bottom: 0;
}
.logo{
    width: 100%;
    /* height: 288px; */
    height: 7rem;
    background: url('../assets/banner.png') center center;
    background-size: 100% 100%;
    line-height: 7rem;
    position: relative;
}
.search{
    width: 80%;
    height: 1.9rem;
    line-height: 1.9rem;
    margin: auto;
}
.lang{
    color: #ffffff;
    font-size: .45rem;
    margin-left: 1rem;

    /* color: #ffffff;
    font-size: .45rem;
    margin-left: 1rem;
    width: 2rem;
    height: 1rem;
    position: relative;
    background: antiquewhite; */
}
.lang span i svg{
    width: .5rem;
    height: 1rem;
    /* position: absolute; */
}




#Language{
    border: none;
    outline: none;
    font-size: 16px;
    color: rgb(51, 50, 50);
}







.colsela{
    width: 2rem;
    cursor: pointer;
}
.choose{
    position: relative;
}
.colsela .choose span{
    display: inline-block;
    width: 1rem;
    height: 1rem;
    /* position: absolute; */
    right: 0;
    top: 50%;
    margin-top: -.5rem;
}
.colsela .choose span svg{
    width: .5rem;
    height: 1.7rem;
    position: absolute;
}
.colsela ul{
    display: none;
    margin-top: -1.1rem;
}
.colsela:hover ul{
    display: block;
}
.colsela ul li{
    height: .7rem;
    cursor: pointer;
    position: relative;
}
.inputA{
    width: 7.8rem;
    box-sizing: border-box;
    position: relative;
}
.icon-search{
    position: absolute;
    width: .9rem;
    height: .9rem;
    left: 100%;
    margin-left: -.9rem;
    z-index: 10;
}
.inputb{
    width: 7.8rem;
    height: .9rem;
    /* background-color: transparent; */
    outline: none;
    border: 1px solid #FFFFFF;
    padding: 0 .5rem;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    margin-top: .45rem;
    color: black;
    border-radius: .1rem;
    font-size: .3.5rem;
}
.logo img{
    width: 3.75rem;
    height: 3.75rem;
    padding: 1.1rem;
}
.logo .name{
    font-size: 36px;
    color: #2a8fc9;
}
.el-input__inner{
    height: 1rem;
}

</style>


// WEBPACK FOOTER //
// src/components/Header.vue